class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.close();
    });

    this.querySelectorAll('button[type="button"].cart-notification__close').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    // Initialize header cart icon accessibility
    this.setHeaderCartIconAccessibility();
    // this.initDiscountCodeHandler();
    // this.initRemoveDiscountHandler();
  }


  // inside class CartNotification { ...
initDiscountCodeHandler() {
  const buttons = this.querySelectorAll('.apply-discount-code');
  if (!buttons.length) return;

  buttons.forEach((btn) => {
    // Remove existing click handler to prevent duplicates
    btn.replaceWith(btn.cloneNode(true));
  });

  // Re-query after clone
  const freshButtons = this.querySelectorAll('.apply-discount-code');

freshButtons.forEach((btn) => {
  btn.addEventListener('click', async (event) => {
    event.preventDefault();
    const self = this;

    const cartDiscount = btn.closest('.cart-discount');
    const discountInput = cartDiscount ? cartDiscount.querySelector('[name="discount"]') : null;
    const discountCode = discountInput ? discountInput.value.trim() : '';
    if (!discountCode) return;

    // show spinner
    const spinner = btn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    document.cookie = `discount_code=${encodeURIComponent(discountCode)}; path=/`;

    try {
      // 🔹 Apply discount + update cart in parallel
      await fetch(`/discount/${encodeURIComponent(discountCode)}`, { credentials: 'same-origin' });

      const updateCartPromise = fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: {} }),
        credentials: 'same-origin',
      });

      // short wait before fetching updated notification (Shopify recalculation)
      await new Promise((r) => setTimeout(r, 150));

      const fetchNotificationPromise = fetch('?section_id=cart-notification', { credentials: 'same-origin' });

      const [updateRes, notificationRes] = await Promise.all([updateCartPromise, fetchNotificationPromise]);
      const cartData = await notificationRes.text();

      // Parse updated cart notification
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(cartData, 'text/html');
      const returnedInner =
        (newDoc.querySelector('#cart-notification') &&
          newDoc.querySelector('#cart-notification').querySelector('.cart-notification__inner')) ||
        newDoc.querySelector('.cart-notification__inner');

      const currentInner = self.notification.querySelector('.cart-notification__inner');
      if (returnedInner && currentInner) {
        currentInner.innerHTML = returnedInner.innerHTML;
      }

      // Keep notification open
      self.notification.classList.add('active', 'animate');
      document.body.classList.add('cart-notification-open');

      // Re-init handlers
      self.initDiscountCodeHandler();
      trapFocus(self.notification);
    } catch (err) {
      console.error('Error applying discount:', err);
    } finally {
      if (spinner) spinner.classList.add('hidden');
    }
  });
});

}

initRemoveDiscountHandler() {
  // Use event delegation on the container (this.notification)
  this.notification.addEventListener('click', async (event) => {
    const btn = event.target.closest('.remove-discount-code');
    if (!btn) return;

    event.preventDefault();
    const discountCode = btn.dataset.discountCode;

    // Spinner
    const spinner = btn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    try {
      // Remove all discounts (Shopify does not allow removing specific codes)
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: "" }),
        credentials: 'same-origin'
      });

      // Small delay for Shopify recalculation
      await new Promise(r => setTimeout(r, 150));

      // Fetch updated cart notification
      const notificationRes = await fetch('?section_id=cart-notification', { credentials: 'same-origin' });
      const cartData = await notificationRes.text();

      const parser = new DOMParser();
      const newDoc = parser.parseFromString(cartData, 'text/html');
      const returnedInner = newDoc.querySelector('.cart-notification__inner');
      const currentInner = this.notification.querySelector('.cart-notification__inner');

      if (returnedInner && currentInner) {
        currentInner.innerHTML = returnedInner.innerHTML;
      }

      // Keep notification open
      this.notification.classList.add('active', 'animate');
      document.body.classList.add('cart-notification-open');

      // Re-initialize apply discount handler if needed
      this.initDiscountCodeHandler();
      trapFocus(this.notification);

    } catch (err) {
      console.error('Error removing discount:', err);
    } finally {
      if (spinner) spinner.classList.add('hidden');
    }
  });
}






  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.setAttribute('aria-expanded', 'false');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(trigger) {
    if (!this.notification) return;

    this.notification.classList.add('animate', 'active');
    document.body.classList.add('cart-notification-open');

    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );
    setTimeout(() => {
      document.addEventListener('click', this.onBodyClick);
    }, 50);
  }

  close() {
    if (!this.notification) return;

    this.notification.classList.remove('active');
    document.body.classList.remove('cart-notification-open');

    const cartLink = document.querySelector('#cart-icon-bubble');
    if (cartLink) cartLink.setAttribute('aria-expanded', 'false');

    document.removeEventListener('click', this.onBodyClick);
    // removeTrapFocus(this.notification);
  }

  renderContents(parsedState) {


    this.querySelector('.mini-cart-notificaion__contents').classList.contains('is-empty') &&
    this.querySelector('.mini-cart-notificaion__contents').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });


    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
       {
        id: 'cart-notification',
        selector: '#cart-notification',
      },
      { id: 'cart-icon-bubble' },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (this.notification.contains(target)) return;
    if (target.closest('#cart-icon-bubble')) return;
    this.close();
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);


class MiniCartItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'cart-notification',
        section: 'cart-notification',
        selector: '.cart-notification__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      }
    ];
  }
}

customElements.define('mini-cart-items', MiniCartItems);





class DiscountApply extends HTMLElement {
  constructor() {
    super();
    this.notification = null;
  }

  connectedCallback() {
    // Always use #cart-notification
    this.notification = document.querySelector('#cart-notification');
    if (!this.notification) return;

    this.initDiscountCodeHandler();
    this.initRemoveDiscountHandler();
  }

showDiscountError(message) {

  let discount_code_container = this.notification.querySelector('.discount-code-container');


  discount_code_container.querySelector('.error-text').textContent = message;
  discount_code_container.classList.add('error-discount');

  

  this.notification.classList.add('active', 'animate', 'error-border');
  document.body.classList.add('cart-notification-open');
}

hideDiscountError() {
  let discount_code_container = this.notification.querySelector('.discount-code-container');
  if (discount_code_container) {
     discount_code_container.classList.remove('error-discount');
      this.notification.classList.remove('error-border');
  }
}


  // initDiscountCodeHandler() {
  //   const buttons = this.querySelectorAll('.apply-discount-code');
  //   if (!buttons.length) return;

  //   // Remove duplicate handlers
  //   buttons.forEach((btn) => btn.replaceWith(btn.cloneNode(true)));

  //   const freshButtons = this.querySelectorAll('.apply-discount-code');
  //   freshButtons.forEach((btn) => {
  //     btn.addEventListener('click', async (event) => {
  //       event.preventDefault();

  //       const discountInput = this.querySelector('[name="discount"]');
  //       const discountCode = discountInput ? discountInput.value.trim() : '';
  //       if (!discountCode) return;

  //       const spinner = btn.querySelector('.loading__spinner');
  //       if (spinner) spinner.classList.remove('hidden');

  //       document.cookie = `discount_code=${encodeURIComponent(discountCode)}; path=/`;

  //       try {



  //         await fetch(`/discount/${encodeURIComponent(discountCode)}`, { credentials: 'same-origin' });

  //         const updateCartPromise = fetch('/cart/update.js', {
  //           method: 'POST',
  //           headers: { 'Content-Type': 'application/json' },
  //           body: JSON.stringify({ updates: {} }),
  //           credentials: 'same-origin',
  //         });

  //         await new Promise(r => setTimeout(r, 150));
  //         const fetchNotificationPromise = fetch('?section_id=cart-notification', { credentials: 'same-origin' });

  //         const [updateRes, notificationRes] = await Promise.all([updateCartPromise, fetchNotificationPromise]);

  //           if (!updateRes.ok) {
  //               const errorText = await updateRes.text();
  //               console.error('Update cart error:', errorText);

  //               this.showDiscountError('Invalid discount code.');
  //               return;
  //             }


  //         const cartData = await notificationRes.text();

  //         const parser = new DOMParser();
  //         const newDoc = parser.parseFromString(cartData, 'text/html');
  //         const returnedInner = newDoc.querySelector('.cart-notification__inner');
  //         const currentInner = this.notification.querySelector('.cart-notification__inner');

  //         if (returnedInner && currentInner) currentInner.innerHTML = returnedInner.innerHTML;

  //         this.notification.classList.add('active', 'animate');
  //         document.body.classList.add('cart-notification-open');

  //         trapFocus(this.notification);





  //       } catch (err) {
  //         console.error('Error applying discount:', err);
  //           this.showDiscountError('Something went wrong. Please try again.');
  //       } finally {
  //         if (spinner) spinner.classList.add('hidden');
  //       }
  //     });
  //   });
  // }


  initDiscountCodeHandler() {
  const buttons = this.querySelectorAll('.apply-discount-code');
  if (!buttons.length) return;

  buttons.forEach((btn) => btn.replaceWith(btn.cloneNode(true)));

  const freshButtons = this.querySelectorAll('.apply-discount-code');
  freshButtons.forEach((btn) => {
    btn.addEventListener('click', async (event) => {
      event.preventDefault();

      const discountInput = this.querySelector('[name="discount"]');
      const discountCode = discountInput ? discountInput.value.trim() : '';
      if (!discountCode) return;

      const spinner = btn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');

      document.cookie = `discount_code=${encodeURIComponent(discountCode)}; path=/`;

      try {
        // Apply discount
        await fetch(`/discount/${encodeURIComponent(discountCode)}`, { credentials: 'same-origin' });

        // Update cart
        const updateCartPromise = fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: {} }),
          credentials: 'same-origin',
        });

        await new Promise(r => setTimeout(r, 150));
        const fetchNotificationPromise = fetch('?section_id=cart-notification', { credentials: 'same-origin' });

        const [updateRes, notificationRes] = await Promise.all([updateCartPromise, fetchNotificationPromise]);

        // 🧩 Step 1: Check cart discounts from /cart.js
        const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
        const cartJson = await cartRes.json();
     
            // check cart-level discounts
            const hasCartLevelDiscount = cartJson.cart_level_discount_applications &&
              cartJson.cart_level_discount_applications.length > 0;

            // check line-item discounts
            const hasLineItemDiscount = cartJson.items &&
              cartJson.items.some(item =>
                item.line_level_discount_allocations &&
                item.line_level_discount_allocations.length > 0
              );

            if (!hasCartLevelDiscount && !hasLineItemDiscount) {
              this.showDiscountError('Dieser Code ist nicht valid.');
              return;
            }else{
              this.hideDiscountError();
            }

        // ✅ Step 2: Replace cart notification
        const cartData = await notificationRes.text();
        const parser = new DOMParser();
        const newDoc = parser.parseFromString(cartData, 'text/html');
        const returnedInner = newDoc.querySelector('.cart-notification__inner');
        const currentInner = this.notification.querySelector('.cart-notification__inner');

        if (returnedInner && currentInner) currentInner.innerHTML = returnedInner.innerHTML;

        this.notification.classList.add('active', 'animate');
        document.body.classList.add('cart-notification-open');
        trapFocus(this.notification);

      } catch (err) {
        console.error('Error applying discount:', err);
        this.showDiscountError('Something went wrong. Please try again.');
      } finally {
        if (spinner) spinner.classList.add('hidden');
      }
    });
  });
}


  initRemoveDiscountHandler() {
    // Event delegation on notification container
    this.notification.addEventListener('click', async (event) => {
      const btn = event.target.closest('.remove-discount-code');
      if (!btn) return;

      event.preventDefault();

      const spinner = btn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');

      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: "" }),
          credentials: 'same-origin'
        });

        await new Promise(r => setTimeout(r, 150));

        const notificationRes = await fetch('?section_id=cart-notification', { credentials: 'same-origin' });
        const cartData = await notificationRes.text();

        const parser = new DOMParser();
        const newDoc = parser.parseFromString(cartData, 'text/html');
        const returnedInner = newDoc.querySelector('.cart-notification__inner');
        const currentInner = this.notification.querySelector('.cart-notification__inner');

        if (returnedInner && currentInner) currentInner.innerHTML = returnedInner.innerHTML;

        this.notification.classList.add('active', 'animate');
        document.body.classList.add('cart-notification-open');

        trapFocus(this.notification);

      } catch (err) {
        console.error('Error removing discount:', err);
      } finally {
        if (spinner) spinner.classList.add('hidden');
      }
    });
  }
}

// Define the custom element
customElements.define('discount-apply', DiscountApply);




 